import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=bf4856ce&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=bf4856ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4856ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf4856ce')) {
      api.createRecord('bf4856ce', component.options)
    } else {
      api.reload('bf4856ce', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=bf4856ce&scoped=true&", function () {
      api.rerender('bf4856ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WmM40PbFsFJc/JS/comp/DocBox.vue"
export default component.exports